import * as React from 'react'

import { PowerReview } from '@thg-commerce/enterprise-components'
import {
  PowerReviewComponentType,
  PowerReviewProps,
} from '@thg-commerce/enterprise-components/src/PowerReview'
import { styled } from '@thg-commerce/enterprise-theme'

export interface PowerReviewReviewSnippetProps extends PowerReviewProps {
  pathname: string
  mainProduct?: boolean
  overrideReviewStyle?: string
}

const PowerReviewReviewSnippetContainer = styled.div`
  .pr-snippet {
    display: flex;
    min-height: 35px;
  }
`

export const PowerReviewReviewSnippet = (
  props: PowerReviewReviewSnippetProps,
) => {
  return (
    <PowerReviewReviewSnippetContainer>
      <PowerReview
        {...props}
        id="pr-reviews-snippet"
        component={PowerReviewComponentType.REVIEW_SNIPPET}
        mainProduct={props.mainProduct}
        overrideReviewStyle={props.overrideReviewStyle}
      />
    </PowerReviewReviewSnippetContainer>
  )
}
